import React from "react";
import "./loader.css";
import { connect } from "react-redux";

function LOADER(props) {
  return null; // Temporarily disabled to debug UI blocking
}

const mapStateToProps = (state) => ({
  loader: state.Loader,
});

export default connect(mapStateToProps, {})(LOADER);
